(function () {
  'use strict';

  var tidioStyle = null;

  function ensureTidioHidden() {
    if (tidioStyle) return;
    tidioStyle = document.createElement('style');
    tidioStyle.id = 'th-tidio-hidden';
    tidioStyle.textContent =
      '#tidio-chat { position: fixed !important; bottom: -9999px !important; right: -9999px !important; opacity: 0 !important; pointer-events: none !important; }';
    document.head.appendChild(tidioStyle);
  }

  function hideTidioWidget() {
    ensureTidioHidden();
    tidioStyle.textContent =
      '#tidio-chat { position: fixed !important; bottom: -9999px !important; right: -9999px !important; opacity: 0 !important; pointer-events: none !important; }';
  }

  function openTidioChat() {
    ensureTidioHidden();
    tidioStyle.textContent = '';

    (function tryOpen() {
      if (window.tidioChatApi) {
        tidioChatApi.show();
        tidioChatApi.open();
      } else {
        window.setTimeout(tryOpen, 300);
      }
    })();
  }

  function dispatchConsentmoAdaShortcut() {
    ['keydown', 'keyup'].forEach(function (type) {
      document.dispatchEvent(
        new KeyboardEvent(type, {
          key: 'x',
          code: 'KeyX',
          keyCode: 88,
          which: 88,
          ctrlKey: true,
          bubbles: true,
          cancelable: true
        })
      );
    });
  }

  function openConsentmoAccessibility() {
    var ada = window.Consentmo && window.Consentmo.accessibility;
    if (ada && typeof ada.toggle === 'function') {
      ada.toggle();
      return true;
    }
    if (ada && typeof ada.open === 'function') {
      ada.open();
      return true;
    }
    dispatchConsentmoAdaShortcut();
    return false;
  }

  function findInComposedPath(event, selector) {
    var nodes =
      typeof event.composedPath === 'function'
        ? event.composedPath()
        : [event.target];

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || el.nodeType !== 1 || !el.matches) continue;
      if (el.matches(selector)) return el;
      if (el.closest && el.closest(selector)) return el.closest(selector);
    }
    return null;
  }

  function closeMobileSidebar() {
    var sidebar = document.getElementById('sidebar-menu');
    if (!sidebar) return;
    if (typeof sidebar.hide === 'function') {
      sidebar.hide();
      return;
    }
    var closeBtn = sidebar.querySelector('[part="close-button"], dialog-close-button button');
    if (closeBtn) closeBtn.click();
  }

  document.addEventListener(
    'click',
    function (e) {
      var chatBtn = findInComposedPath(e, '.topbar-chat-btn');
      if (chatBtn) {
        e.preventDefault();
        e.stopPropagation();
        closeMobileSidebar();
        openTidioChat();
        return;
      }

      var adaBtn = findInComposedPath(e, '[data-consentmo-ada-trigger]');
      if (adaBtn) {
        e.preventDefault();
        e.stopPropagation();
        closeMobileSidebar();
        if (openConsentmoAccessibility()) return;

        var attempts = 0;
        var retryTimer = window.setInterval(function () {
          attempts += 1;
          if (openConsentmoAccessibility() || attempts >= 20) {
            window.clearInterval(retryTimer);
          }
        }, 250);
      }
    },
    true
  );

  ensureTidioHidden();

  document.addEventListener('tidioChat-ready', function () {
    if (!window.tidioChatApi) return;
    tidioChatApi.on('close', hideTidioWidget);
  });
})();
